import WPBaseDAO from "./WPBaseDao";
import ConteudoModel from "../../model/ConteudoModel";
import CategoriaModel from "../../model/CategoriaModel";
import BannerModel from "../../model/BannerModel";

class WPListasDAO extends WPBaseDAO {
  private static instance: WPListasDAO;
  private endpoint = `${super.getBasePath()}`;
  private endpointCache = `${super.getAPIPath()}/api`;

  private constructor() {
    super();
  }

  public static getInstance(): WPListasDAO {
    if (!WPListasDAO.instance) {
      WPListasDAO.instance = new WPListasDAO();
    }
    return WPListasDAO.instance;
  }

  public async getListas(obterImagens: boolean): Promise<ConteudoModel[]> {
    return this.get(
      "REQ_WP_LISTAS",
      `${this.endpointCache}/content/listas-v2`
    ).then((r: any) =>
      Promise.all(
        r.data.data.map((i: any) =>
          ConteudoModel.toModel(i, "Listas", obterImagens).then((c) => c)
        )
      )
    );
  }
  public async getReceitas(obterImagens: boolean): Promise<ConteudoModel[]> {
    return this.get(
      "REQ_WP_RECEITAS",
      `${this.endpointCache}/content/receitas-v2`
    ).then((r: any) =>
      Promise.all(
        r.data.data.map((i: any) =>
          ConteudoModel.toModel(i, "Receitas", obterImagens).then((c) => c)
        )
      )
    );
  }

  public async getDicas(obterImagens: boolean): Promise<ConteudoModel[]> {
    return this.get(
      "REQ_WP_DICAS",
      `${this.endpointCache}/content/dicas-v2`
    ).then((r: any) =>
      Promise.all(
        r.data.data.map((i: any) =>
          ConteudoModel.toModel(i, "Dicas", obterImagens).then((c) => c)
        )
      )
    );
  }

  public async getCategorias(): Promise<CategoriaModel[]> {
    return this.get(
      "REQ_WP_CATEGORIAS",
      `${this.endpointCache}/content/categorias-icones`
    ).then((r: any) =>
      Promise.all(
        r.data.map((i: any) =>
          CategoriaModel.toModel(
            {
              ID: i.id,
              StorageURL: i.icon,
              YourID: i.yourid,
            },
            1,
            ""
          )
        )
      )
    );
  }

  public async getBanners(): Promise<BannerModel[]> {
    return this.get(
      "REQ_WP_BANNERS",
      `${this.endpointCache}/content/banners`
    ).then((r: any) =>
      Promise.all(r.data.map((i: any) => BannerModel.toModel(i)))
    );
  }
}

export default WPListasDAO;
